import React from 'react';
import { Provider } from 'react-redux';
import { matchPath } from 'react-router-dom';
import PathViewer from './index';
import pathViewerStore from '../../stores/PathViewerStore.js';

const isPreviewing = () =>
  !!matchPath(window.location.pathname, { path: '/preview/' });

const PathViewerRoot = props => {
  return (
    <Provider
      store={pathViewerStore({
        pathViewer: { ...props.pathViewer, previewing: isPreviewing() },
      })}
    >
      <PathViewer />
    </Provider>
  );
};

export default props => <PathViewerRoot {...props} />;
